/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Clinical_Nutrition_TermsInputs */

const en_service_type_clinical_nutrition_terms = /** @type {(inputs: Service_Type_Clinical_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clinical dietitian, insulin resistance, diabetes, thyroid, hashimoto, ibs, sibo, food intolerance, cholesterol, pcos`)
};

const pl_service_type_clinical_nutrition_terms = /** @type {(inputs: Service_Type_Clinical_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dietetyk kliniczny, insulinooporność, cukrzyca, hashimoto, tarczyca, jelita, ibs, sibo, nietolerancja, alergia pokarmowa, cholesterol, nadciśnienie, pcos`)
};

/**
* | output |
* | --- |
* | "clinical dietitian, insulin resistance, diabetes, thyroid, hashimoto, ibs, sibo, food intolerance, cholesterol, pcos" |
*
* @param {Service_Type_Clinical_Nutrition_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_clinical_nutrition_terms = /** @type {((inputs?: Service_Type_Clinical_Nutrition_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Clinical_Nutrition_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_clinical_nutrition_terms(inputs)
	return en_service_type_clinical_nutrition_terms(inputs)
});